import { equals } from '@execonline-inc/collections';
import { State } from './Types';

export const isLoading = (state: State) => {
  switch (state.kind) {
    case 'loading':
    case 'filtering':
      return true;
    case 'ready':
    case 'filtered':
    case 'option-selected':
    case 'error':
      return false;
  }
};

export const options = (state: State) => {
  switch (state.kind) {
    case 'loading':
    case 'ready':
    case 'filtering':
    case 'error':
      return [];
    case 'filtered':
      return state.optionsResource.payload;
    case 'option-selected':
      const { selectedValue, optionsResource } = state;
      return optionsResource.payload.filter(({ value }) => equals(value, selectedValue.value));
  }
};

export const getPlaceholder = (state: State) => {
  switch (state.kind) {
    case 'filtered':
    case 'option-selected':
    case 'ready':
      return 'Type to search...';
    case 'loading':
    case 'filtering':
    case 'error':
      return 'Loading...';
  }
};
